import {
  ChooseSlotPayload,
  ClientPage,
  Delivery,
  GetSlotsPayload,
  GetSlotsResponse,
  GetUnavailableDatesPayload,
  GetUnavailableDatesResponse,
  MultiTrackingGlobalOrder,
  ScorePayload,
} from '@/types'
import DeliveryRepository, { IDeliveryRepository } from './DeliveryRepository'

export class DeliveryService {
  private repository: IDeliveryRepository

  constructor() {
    this.repository = new DeliveryRepository('deliveries')
  }

  async get(
    accessToken: string,
    params: Record<string, any> = {},
  ): Promise<{
    delivery: Delivery
    deliveries?: Delivery[]
    globalOrder?: MultiTrackingGlobalOrder | null
    pages: ClientPage[]
    languages?: string[]
    minDeliveryPromiseDate: string | null
  }> {
    const {
      delivery,
      deliveries,
      globalOrder,
      pages,
      languages = [],
      minDeliveryPromiseDate,
    } = await this.repository.get(accessToken, params)

    return { delivery, pages, languages, deliveries, globalOrder, minDeliveryPromiseDate }
  }

  async createScore(accessToken: string, payload: ScorePayload): Promise<void> {
    await this.repository.createScore(accessToken, payload)
  }

  async getSlots(accessToken: string, params: GetSlotsPayload): Promise<GetSlotsResponse> {
    const { data } = await this.repository.getSlots(accessToken, params)
    return data
  }

  async chooseSlot(
    accessToken: string,
    payload: ChooseSlotPayload,
  ): Promise<{ status: string; message?: string }> {
    return this.repository.chooseSlot(accessToken, payload)
  }

  async getUnavailableDates(
    accessToken: string,
    params: GetUnavailableDatesPayload,
  ): Promise<GetUnavailableDatesResponse> {
    const { data } = await this.repository.getUnavailableDates(accessToken, params)
    return data
  }
}

export default new DeliveryService()
